export const colors = {
    primary: '#267E9C',
    secondary: '#5198B0',
    white: '#FFFFFF',
};
